export const APP_VERSION = '1.95.0';
